const _nav = [
  {
    name: "Language",
    to: "/settings/select-language",
  },
  {
    name: "Notifications",
    to: "/settings/notification-settings",
  },
  {
    name: "Privacy Policy",
    to: "/settings/privacy-policy",
  },
  {
    name: "Terms & Conditions",
    to: "/settings/terms-conditions",
  },
  {
    name: "Donation Cancellation & Refund Policy",
    to: "/settings/donation-cancellation",
  },
  {
    name: "Shipping & Delivery Policy",
    to: "/settings/shipping-delivery-policy",
  },
];

export default _nav;
